module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_third.ad72a37e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_third.png
// module id = 1388
// module chunks = 11